import React, { FC } from "react";
import { Grid } from "@/components/Grid";
import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { useFela } from "react-fela";
import { Image } from "@/components/Image";
import { Button } from "@/components/Button";
import { ListElement } from "@/components/ListElement";
import { IListElement } from "@/components/ListElement/types";
import { signUpForFreeTrialAccount } from "@/services/freeTrialAccountService";

type ITryOutSectionBackup = {
  title: string;
  subtitle: string;
  src: string;
  elements: IListElement[];
  cta?: string;
  onCtaClick?: (params: any) => void;
};

export const TryOutSectionBackup: FC<ITryOutSectionBackup> = ({
  title,
  subtitle,
  src,
  elements,
  cta = "Try for free",
  onCtaClick = signUpForFreeTrialAccount,
}) => {
  const { colors, bp } = useTheme();
  const { css } = useFela();

  return (
    <Grid
      wrapperStyle={{ background: colors.GRADIENT_BLUE }}
      customStyle={{
        justifyContent: "space-between",
        flexDirection: "column",
        gap: 60,
        [bp.FROM_DESKTOP]: { flexDirection: "row", justifyContent: "center" },
      }}
    >
      <div>
        <Heading
          as="h3"
          customStyle={{
            color: colors.WHITE,
            marginBottom: 16,
          }}
        >
          {title}
        </Heading>
        <p
          className={css({
            color: colors.WHITE,
          })}
        >
          {subtitle}
        </p>
        <ul
          className={css({
            margin: 0,
            padding: 0,
            listStyleType: "none",
          })}
        >
          {elements.map((element, index) => (
            <ListElement
              {...element}
              key={`ListElement-${element.id}-${index}`}
              wrapperStyle={{ marginTop: 32, alignItems: "center" }}
              textStyle={{
                fontSize: 16,
                lineHeight: "24px",
                color: colors.WHITE,
              }}
              badgeStyles={{
                boxShadow: "none",
                backgroundColor: "none",
              }}
            />
          ))}
        </ul>
        <Button
          customStyle={{ width: "auto", padding: "0 30px", marginTop: 32 }}
          onClick={onCtaClick}
        >
          {cta}
        </Button>
      </div>
      <div
        className={css({
          display: "grid",
          placeItems: "center",
          padding: "0 30px",
          maxWidth: "100%",
        })}
      >
        <Image
          customStyle={{ objectFit: "contain", maxWidth: "100%" }}
          src={src}
        />
      </div>
    </Grid>
  );
};
